/* eslint-disable no-unused-vars */
import { useLocalStorageState } from '@frontend/common';
import { FeatureTarget, Functionality, FunctionalityType } from '@frontend/functionality/types';
import { useAccountRepository, useBrandingRepository, useLicenseRepository } from '@frontend/repository';
import { useMemo, useRef } from 'react';

interface ViewProps {
    navbarRef: React.RefObject<HTMLDivElement | null>;
    navbarPinned: boolean;
    setNavbarPinned: (value: boolean) => void;
    hovered: boolean;
    setHovered: (value: boolean) => void;
    functionalities?: Functionality[] | null;
    currentAccount: string;
    brandingLogoExpanded: string;
    brandingLogoCollapsed: string;
}

const useNavbar = (): ViewProps => {
    const { currentAccount } = useAccountRepository();
    const { logo_navbar_expanded, logo_navbar_collapsed } = useBrandingRepository();
    const navbarRef = useRef<HTMLDivElement | null>(null);
    const [navbarPinned, setNavbarPinned] = useLocalStorageState('navbar-pinned', true);
    const [hovered, setHovered] = useLocalStorageState('navbar-hovered', false);
    const { functionalities } = useLicenseRepository();

    const filteredFunctionalities = useMemo(() => {
        return functionalities?.filter((f) => f.target === FeatureTarget.PLATFORM && f.type === FunctionalityType.CORPORATE && f.hidden !== true) || null;
    }, [functionalities]);

    return {
        navbarRef,
        navbarPinned,
        setNavbarPinned,
        hovered,
        setHovered,
        functionalities: filteredFunctionalities,
        currentAccount,
        brandingLogoExpanded: logo_navbar_expanded,
        brandingLogoCollapsed: logo_navbar_collapsed
    };
};

export default useNavbar;
